import { FinanceOptionDetailsDeferredInterest } from './finance-option-details-deffered-interest';
import { FinanceOptionDetailsFixedApr } from './finance-option-details-fixed-apr';
import { FinanceOptionDetailsProps } from './finance-option-details-shared';

export const FinanceOptionDetails = ({ financeOption }: FinanceOptionDetailsProps) => {
  if (financeOption.type === 'deferred_interest') {
    return <FinanceOptionDetailsDeferredInterest financeOption={financeOption} />;
  }
  return <FinanceOptionDetailsFixedApr financeOption={financeOption} />;
};
